import React from 'react';
import { fmtFull } from '../../lib/format';

/**
 * Right-hand "You receive" summary card: preview output + exchange rate
 * and fee disclosure.
 */
export default function VaultPreviewCard({ mode, preview, apy, exchangeRate }) {
  return (
    <div className="rounded-2xl p-5 border border-palm-mint/15 bg-gradient-to-br from-palm-teal/25 via-black/20 to-transparent">
      <div className="text-[11px] tracking-[0.22em] uppercase text-palm-mint/70">
        You receive
      </div>
      <div className="mt-2 flex items-baseline gap-2">
        <span
          className="font-display font-black text-3xl md:text-4xl tracking-tight text-gradient"
          data-testid="preview-output"
        >
          {fmtFull(preview)}
        </span>
        <span className="text-sm font-semibold text-white/80">
          {mode === 'deposit' ? 'yPUSD' : 'PUSD'}
        </span>
      </div>

      <div className="mt-5 space-y-2 text-sm">
        <Row
          label="Exchange rate"
          value={
            mode === 'deposit'
              ? `1 PUSD = ${exchangeRate} yPUSD`
              : `1 yPUSD = ${(1 / exchangeRate).toFixed(4)} PUSD`
          }
        />
        <Row label="Network fee (est.)" value="~0.00025 SOL" />
        <Row label="APY" value={`${apy}%`} highlight />
        {mode === 'withdraw' && <Row label="Yield bonus" value="+1.5%" highlight />}
      </div>
    </div>
  );
}

function Row({ label, value, highlight }) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-white/55">{label}</span>
      <span className={highlight ? 'text-palm-lime font-semibold' : 'text-white/90 font-medium'}>
        {value}
      </span>
    </div>
  );
}
